import React, { useState } from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import PageRoutes from '@utils/page-routes'

interface Props {
  titleId: string
}

const EditScoreDialog: React.FC<Props> = ({ titleId }) => {
  const { t } = useTranslation()
  const [redirecting, setRedirecting] = useState(false)

  return (
    <Dialog
      name="edit_score"
      title={t('action.editScore')}
      maxWidth={410}
      okBtn={{
        text: t('action.editScore'),
        disabled: redirecting,
        action: () => {
          setRedirecting(true)
          window.location.href = PageRoutes.titleEditScorePath(titleId)
        },
      }}
      cancelBtn>
      <Trans i18nKey="messages.editScoreDetails" />
    </Dialog>
  )
}

export default EditScoreDialog
